import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=74a9b896&"
import script from "./StatisticCard.vue?vue&type=script&lang=js&"
export * from "./StatisticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports